import { REDUX_MODEL_KEY } from '../../constants/key'
import { REDUX_LOCAL_KEY } from '../../constants/local-key'
import getLocalKeysReduxUtil from '../get-local-keys'
import {
  isEmptyUtil,
  omitObjectUtil
} from 'packages/src'

function hasAssociationChangeReduxUtil (instance) {
  return Object.keys(instance[REDUX_MODEL_KEY.CHANGED] || {})
    .includes(REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE)
}

/**
 * Checks if the given `instance` has changed.
 * @param  {Instance} instance
 * @return {Boolean}
 */
function hasChangedReduxUtil (instance) {
  if (!instance) {
    return false
  }
  if (hasAssociationChangeReduxUtil(instance)) {
    return true
  }
  const localKeys = getLocalKeysReduxUtil(instance)
  const changed = omitObjectUtil(instance[REDUX_MODEL_KEY.CHANGED], localKeys)
  return !isEmptyUtil(changed)
}

export {
  hasAssociationChangeReduxUtil,
  hasChangedReduxUtil
}
